import { useState } from 'react';
import Datepicker from 'react-tailwindcss-datepicker';
import type { DateRangeType, DateType } from 'react-tailwindcss-datepicker';

type Props = {
  /** 対象日の変更時のイベント。 */
  onDateChange: (startDate: DateType, endDate: DateType) => void;
  /** 選択された日付。 */
  selectedDate: DateRangeType;
};

/** 対象日のコンポーネント */
export const TargetDate = ({ onDateChange, selectedDate }: Props) => {
  const [value, setValue] = useState<DateRangeType>(selectedDate);

  /**ページリロードでselectedDateが変更されたときにvalueが更新されない為、更新を行う。 */
  if (
    selectedDate.startDate !== value.startDate ||
    selectedDate.endDate !== value.endDate
  ) {
    setValue(selectedDate);
  }

  const handleChangeDate = (newValue: DateRangeType | null) => {
    if (newValue) {
      setValue(newValue);
      onDateChange(newValue.startDate, newValue.endDate);
    }
    if (newValue === null) {
      setValue({ startDate: null, endDate: null });
      onDateChange(null, null);
    }
  };

  return (
    <div className="w-[320px]">
      <Datepicker
        useRange={false}
        asSingle={true}
        value={value}
        onChange={handleChangeDate}
        inputClassName="w-full p-[16px] text-[16px] noto-sans-jp-regular text-textPrimary placeholder-textPrimary border border-textPrimary rounded-[4px] bg-background focus:outline-none"
        toggleClassName="absolute text-primary right-0 h-full px-[16px] text-gray-400 focus:outline-none"
        placeholder="対象日"
        displayFormat="YYYY/MM/DD"
        i18n="ja"
        maxDate={new Date()}
      />
    </div>
  );
};
